"use strict";
import { theme } from "../../ThemeContext/ThemeObject";
export const styles = {
  candidatesPageContainer: {
    backgroundColor: theme.palette.common.white,
    padding: "40px",
    rowGap: 4
  },
  candidatesPageHeader: {
    fontWeight: "bold",
    fontSize: "38px",
    color: "#666666"
  },
  filterActive: {
    color: "red"
  },
  filterInactive: {
    color: "grey"
  },
  noBorderField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none"
      },
      "&:hover fieldset": {
        border: "none"
      },
      "&.Mui-focused fieldset": {
        border: "none"
      }
    }
  }
};
